module.exports = __webpack_public_path__ + "img/Avatar-3.c8c35e6a.gif";